// src/core/services/userProfile.service.ts
import api from "@/core/services/axios";
import type { UserContext } from "@/core/store/context";

export class UserProfileService {
  constructor(private readonly baseRoute = "/users") {}

  async fetchUserProfile(): Promise<UserContext> {
    const res = await api.get<UserContext>(`${this.baseRoute}/me`);
    return res.data;
  }

  async fetchUserProfileById(id: string): Promise<UserContext> {
    const res = await api.get<UserContext>(`${this.baseRoute}/${id}`);
    return res.data;
  }
}

export const userProfileService = new UserProfileService();
